import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { IBoardingButton, IBoardingCheckList } from '../interfaces/boarding-check-list';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BoardingCheckListService {
  public url = '/api/boardingchecklist';

  public changeBoardingCheckList: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(public http: HttpClient) {}

  public GetBoardingCheckList(): Promise<IBoardingCheckList> {
    return this.http
      .get<IBoardingCheckList>(`${this.url}`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public needRedirectToCheckListPage(): Promise<any> {
    return this.http
      .get(`${this.url}/needRedirectToCheckListPage`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public Hide(): Promise<boolean> {
    return this.http
      .get(`${this.url}/hide`, { responseType: 'text' })
      .toPromise()
      .then((text) => text == 'true')
      .catch(this.handleError);
  }

  public MarkAsUsed(button: IBoardingButton): Promise<void> {
    return this.http
      .post(`${this.url}/markasused`, button)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public extractData(res: any) {
    return res;
  }

  public handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(fullErrorMessage);
    return Promise.reject(fullErrorMessage);
  }
}
